import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@everysens/frontend-shared-v2';
import { UserPermissions } from '@rtls/shared/user/user-permissions';
import { TenantConfiguration } from 'data';
import { tap, filter, takeUntil } from 'rxjs/operators';
import { TenantConfigurationService } from '@rtls/core/tenant/configuration/tenant-configuration.service';
import { isNil } from 'lodash-es';
import { Subject } from 'rxjs';

@Component({
	selector: 'es-redirect',
	template: '',
	standalone: true,
})
export class RedirectComponent implements OnInit, OnDestroy {
	private destroy = new Subject<void>();
	constructor(
		private router: Router,
		private userService: UserService,
		private tenantConfigurationService: TenantConfigurationService,
	) {}

	ngOnInit() {
		this.tenantConfigurationService
			.selectHasConfiguration(TenantConfiguration.EXECUTION_ACCESS_CONTROL)
			.pipe(
				takeUntil(this.destroy),
				filter((res) => !isNil(res)),
				tap((hasExecutionAccessControl) => {
					if (hasExecutionAccessControl) {
						if (this.userService.checkIfUserHasAllPermissions(UserPermissions.readStatistics)) {
							this.router.navigate(['/dashboard']).then();
						} else if (this.userService.checkIfUserHasAllPermissions([UserPermissions.readYardAssets])) {
							this.router.navigate(['/yard/assets/list']).then();
						} else if (this.userService.checkIfUserHasAllPermissions([UserPermissions.readTransports])) {
							this.router.navigate(['/transports/execution']).then();
						}
					} else {
						this.router.navigate(['/dashboard']).then();
					}
				}),
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		this.destroy.next();
		this.destroy.complete();
	}
}
